<div class="modal-container main-font">
  <div class="header-modal">
    <p class="mb-0 text-header">Modifica visibilità</p>
  </div>
  <div class="content-modal my-scrollbar w-100">
    <div class="menu-container" *ngFor="let menu of menus">
      <p class="mb-0 text-menu">{{ menu.title }}</p>
      <div
        class="section-container w-100"
        *ngFor="let submenu of menu.subMenus">
        <div class="d-flex align-items-center gap-3">
          <i class="icons fill-svg-blue-700" [ngClass]="submenu.icon"></i>
          <p class="mb-0 text-section">{{ submenu.title }}</p>
        </div>
        <nz-switch
          nzSize="small"
          [ngModel]="isSectionActive(submenu.section)"
          (ngModelChange)="setAccessSection(submenu.section, $event)">
        </nz-switch>
      </div>
    </div>
  </div>
  <div class="footer-modal w-100">
    <button class="secondary-btn w-50" (click)="closeModal()">Chiudi</button>
  </div>
</div>
